import React from 'react';

interface TraversalDirectionProps {
  direction: 'outwards' | 'inwards' | 'both';
  onClick: (newDirection: 'outwards' | 'inwards' | 'both') => void;
}

const TraversalDirection: React.FC<TraversalDirectionProps> = ({
  direction,
  onClick,
}) => {
  const handleDirectionChange = () => {
    const newDirection =
      direction === 'outwards'
        ? 'inwards'
        : direction === 'inwards'
        ? 'both'
        : 'outwards';
    onClick(newDirection);
  };

  return (
    <div
      className={`traversal-direction ${
        direction === 'both'
          ? 'both-icon'
          : direction === 'outwards'
          ? 'expand-icon'
          : 'collapse-icon'
      }`}
      onClick={handleDirectionChange}
      style={{
        cursor: 'pointer',
        display: 'inline-block',
        width: '22px',
        height: '22px',
      }}
    >
      {direction === 'both' && (
        <>
          <span className="both-direction-icon" />
        </>
      )}
    </div>
  );
};

export default TraversalDirection;
